<template>
    <div class="c-substep-trail" :style="rootStyle">
        <template v-for="(st, i) in SUB_STEPS">
            <span v-if="i > 0" :key="`sep-${st.id}`" :style="sepStyle" />
            <span :key="st.id" :style="stepStyle(i)">
                <span :style="iconStyle(i)">{{ iconChar(i) }}</span>
                <span :style="labelStyle(i)">{{ st.label }}</span>
            </span>
        </template>
    </div>
</template>

<script>
import { C_INK, C_INK2, C_HAIR, C_PANEL, C_MUTED, C_GREEN, FONT_BODY } from './tokens';

// The 4 sub-steps a brand walks through. Locked order:
// Service → Invoice → Payment → Amounts.
const SUB_STEPS = [
    { id: 'service', label: 'Service' },
    { id: 'invoice', label: 'Invoice' },
    { id: 'payment', label: 'Payment' },
    { id: 'amounts', label: 'Amounts' },
];

export default {
    name: 'SubStepTrail',
    props: {
        // Index of the current sub-step (0-3).
        subIdx: { type: Number, required: true },
        // Map of sub-step id → 'yes' | 'no' answer collected so far.
        // Drives the green-vs-grey colour of past-step icons.
        answers: { type: Object, default: () => ({}) },
    },
    data() {
        return { SUB_STEPS };
    },
    computed: {
        rootStyle() {
            return {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '22px',
                padding: '10px 14px',
                background: C_PANEL,
                borderRadius: '999px',
                fontSize: '12px',
            };
        },
        sepStyle() {
            return { width: '14px', height: '1px', background: C_HAIR, display: 'inline-block' };
        },
    },
    methods: {
        isCurrent(i) { return i === this.subIdx; },
        isDone(i)    { return i < this.subIdx; },
        isFuture(i)  { return i > this.subIdx; },
        isNo(i) {
            return this.isDone(i) && this.answers[SUB_STEPS[i].id] === 'no';
        },
        iconChar(i) {
            if (this.isCurrent(i)) return i + 1;
            if (this.isDone(i)) return this.isNo(i) ? '–' : '✓';
            return i + 1;
        },
        stepStyle(i) {
            const cur = this.isCurrent(i);
            const fut = this.isFuture(i);
            return {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                padding: '4px 10px',
                borderRadius: '999px',
                background: cur ? C_INK : 'transparent',
                color: cur ? '#fff' : fut ? C_MUTED : C_INK2,
            };
        },
        iconStyle(i) {
            const cur = this.isCurrent(i);
            const done = this.isDone(i);
            return {
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: cur
                    ? '#fff'
                    : done
                        ? this.isNo(i) ? C_HAIR : C_GREEN
                        : 'transparent',
                color: cur ? C_INK : '#fff',
                border: this.isFuture(i) ? `1.5px solid ${C_HAIR}` : 'none',
                fontSize: '10px',
                fontWeight: 700,
            };
        },
        labelStyle(i) {
            return {
                fontWeight: this.isCurrent(i) ? 700 : 500,
                fontFamily: FONT_BODY,
            };
        },
    },
};
</script>
